import * as _ from 'lodash';

class HierarchyBuilder {

    addHierarchyData(clients, accounts) {
        this.clientsById = {};
        this.nodesByAccount = {};

        _.forEach(clients, c => {
           this.clientsById[c.account.client_id] = c;
        });

        _.forEach(accounts, acct => {
            this.nodesByAccount[acct.id] = new HierarchyNode(acct, this.clientsById[acct.client_id]);
        });

        _.forEach(accounts, acct => {
            if (acct.parent_id) {
                this._addChild(this.nodesByAccount[acct.parent_id], this.nodesByAccount[acct.id])
            }
        });

        _.forOwn(this.nodesByAccount, n => {
            if (n.parent === null) {
                this._processRootNode(n);
            }
        });
    }

    _addChild(parent, child) {
        child.parent = parent;
        parent.children.push(child);
    }

    _processRootNode(node) {
        this._processNode(node, node);
    }

    _processNode(node, ancestor) {
        // ancestor
        // arr including children
        // count of client children

        node.ancestor = ancestor;

        if (node.children.length > 0) {

            // get the summed child stats and add them to this node
            const childStats = _.map(node.children, child => this._processNode(child, ancestor));

            const summed = _.reduce(childStats, (sum, n) => this._sum(sum, n));

            node.count_descendant_accounts = summed.count_accounts;
            node.count_descendant_clients = summed.count_clients;
            node.descendant_arr = summed.sum_arr;

            // now return the child stats + the values for this account
            return this._sum(this._statsForAccount(node), summed);

        } else {
            return this._statsForAccount(node);
        }
    }

    _statsForAccount(acct) {
        let isClient = 0;
        let arr = 0;

        if (acct.client) {
            isClient = 1;
            arr = acct.client.account.arr_prorated;
        }

        return {count_accounts: 1, count_clients: isClient, sum_arr: arr};
    }

    _sum(first, second) {
        return {
            count_accounts: first.count_accounts + second.count_accounts,
            count_clients: first.count_clients + second.count_clients,
            sum_arr: first.sum_arr + second.sum_arr
        };
    }
}

class HierarchyNode {

    constructor(account, client) {
        this.name = account.name;
        this.id = account.id;
        this.children = [];
        this.client = null;
        this.count_descendant_accounts = 0;
        this.count_descendant_clients = 0;
        this.descendant_arr = 0;

        if (client) {
            this.client = client;
            client.hierarchy = this;
        }

        this.parent = null;
    }
}

export default HierarchyBuilder;


// WEBPACK FOOTER //
// ./src/HierarchyBuilder.js